/**
 * Instantly moves the window to the document top. Use after phase / route
 * changes where smooth scroll can race layout (e.g. quiz subtree unmount).
 */
export function scrollToDocumentTopImmediate(): void {
  if (typeof window === 'undefined') return;
  window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
}

/**
 * Scrolls the window to the document top, honoring `prefers-reduced-motion`
 * (instant jump when reduced motion is preferred; smooth otherwise).
 */
export function scrollToDocumentTopPreferred(): void {
  if (typeof window === 'undefined') return;
  const reduce =
    window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false;
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: reduce ? 'auto' : 'smooth',
  });
}

/**
 * Scrolls an element into view, honoring `prefers-reduced-motion`.
 */
export function scrollIntoViewPreferred(
  element: Element | null | undefined,
  options?: {
    block?: ScrollLogicalPosition;
    inline?: ScrollLogicalPosition;
  },
): void {
  if (!element || typeof window === 'undefined') return;
  const reduce =
    window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false;
  element.scrollIntoView({
    behavior: reduce ? 'auto' : 'smooth',
    block: options?.block ?? 'nearest',
    inline: options?.inline ?? 'nearest',
  });
}
